import { AuthContext } from 'context/auth/authProvider';
import { useContext } from 'react';

const useAuth = () => useContext(AuthContext);

export { useAuth };
